<template>
    <b-button
        type="submit"
        :class="btnVariant"
        :disabled="isLoading || isDisabled"
        v-on:click.prevent="doAction"
    >
        <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ $t(text) }}
    </b-button>
</template>

<script>
    export default {
        name: "SubmitButton",
        props: {
            isLoading: {
                type: Boolean,
                required: true,
            },
            doAction: {
                type: Function,
                required: true,
            },

            // optionals
            isDisabled: {
                type: Boolean,
                default: false,
            },
            text: {
                type: String,
                default: "add",
            },
            btnVariant: {
                type: String,
                default: "btn bg-main border-0 hover:bg-hoverMain rounded h-11 focus:ring-0 font-bold w-full",
            }
        },
    }
</script>

<style scoped>

</style>